import * as React from "react";
import TextInput, { ITextInputProps } from "./TextInput";
import type { UseFormRegisterReturn } from "react-hook-form";
import PasswordInput from "./PasswordInput";
import { twMerge } from "tailwind-merge";
import ErrorText from "components/Typography/ErrorText";

interface IFormTextInputProps extends ITextInputProps {
  register?: () => UseFormRegisterReturn;
  label?: string;
  labelClassname?: string;
  type?: "text" | "password";
  error?: string;
}

const FormTextInput: React.FunctionComponent<IFormTextInputProps> = ({
  register,
  label,
  error,
  type,
  labelClassname,
  ...props
}) => {
  return (
    <div className="flex flex-col gap-1">
      <label
        className={twMerge("block text-black/80 font-semibold", labelClassname)}
      >
        {label}
      </label>
      {(type === "text" || type === undefined) && (
        <TextInput
          {...props}
          {...(register && register())}
          className={twMerge(props.className, error && "border-red-300")}
        />
      )}
      {type === "password" && (
        <PasswordInput
          {...props}
          {...(register && register())}
          className={twMerge(props.className, error && "border-red-300")}
        />
      )}
      {error && <ErrorText>{error}</ErrorText>}
    </div>
  );
};

export default FormTextInput;
